import React from 'react';
import tabletImage from '../../components/LandingPage/images/tabImg.png';  // Update with your tablet image path

const StepOne = () => {
    return (
        <div className="flex flex-col lg:flex-row justify-between items-center w-full py-12 px-2">
            {/* Left Section: Text */}
            <div className="lg:w-[30%] sm:w-[100%] text-center sm:text-left mb-8 lg:mb-0">
                <h1 className="text-3xl md:text-4xl font-raleway font-extrabold text-black">
                    Perfect Pairings for <span className="text-[#A67FAA] font-raleway">Every Dish</span>
                </h1>
                <p className="text-xl md:text-2xl mt-10 font-publicSans font-semibold  text-black">
                    Elevate your cooking using Cook-E’s expertly suggested pairings inspired by culinary traditions from around the world!
                </p>
            </div>

            {/* Right Section: Tablet Image */}
            <div className="lg:w-[70%] flex justify-end ">
                <img src={tabletImage} alt="Tablet" className="w-full max-w-2xl" />
            </div>
        </div>
    );
};

export default StepOne;
